import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import TelecomHero from './components/TelecomHero';
import ServicesSection from './components/ServicesSection';
import CoverageSection from './components/CoverageSection';
import PartnersSection from './components/PartnersSection';

export default function Telecommunications() {
  useEffect(() => {
    document.title = 'Telecommunications | Holston Development Group';
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <TelecomHero />
        <ServicesSection />
        <CoverageSection />
        <PartnersSection />
      </main>
      <Footer />
    </div>
  );
}
